export class TypedMap<T extends object = object> {

	private map = new Map<string, T>();

	private constructor() {}

	static create<T extends object>(): TypedMap<T> {
		return new TypedMap();
	}

	get<K extends keyof T>(key: K): T[K] {
		return this.map.get(key as string) as T[K];
	}

	set<K extends string>( key: K, value: T ): TypedMap<T> {
		this.map.set(key, value);
		return this;
	}

	has<K extends keyof T>(key: K): boolean {
		return this.map.has(key as string);
	}
}
